<template>
  <!-- 
    name: 覃刚
    function: 原料数据库-新增
    date: 2021-03-05
 -->
  <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
    <a-form-item label="量表名称">
      <a-input
        placeholder="请输入量表名称"
        v-decorator="['name', { rules: [{ required: true, message: '请输入量表名称' },{validator: checkName}] }]"
      />
    </a-form-item>
    <a-form-item label="重量单位">
      <a-select
        placeholder="请选择重量单位"
        v-decorator="['weightUnit', { rules: [{ required: true, message: '请选择重量单位' }] }]"
        style="width: 100%；"
      >
        <a-select-option value="KG">
          KG
        </a-select-option>
        <a-select-option value="Ton">
          Ton
        </a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="有效期">
      <a-range-picker style="width:100%" v-decorator="['date', { rules: [{ required: true, message: '请选择有效期' }] }]" :locale="locale"/>
    </a-form-item>
  </a-form>
</template>
<script>
import {checkEmpty} from '@/components/Common/Utils/Utils'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
export default {
  data(){
    return {
      form: this.$form.createForm(this,{name: 'EstimateAdd'}),
      locale
    }
  },
  methods:{
    checkName(rule, value, callback) {
      if(value){
        let str = checkEmpty(value,'量表名称')
        if(str) callback(str);
      }
      callback()
    },
  }
}
</script>